import { SiteHomePageRoute } from '@townsquare/router/route-types';
import { reactionUpdateActionRoute } from '@townsquare/routes/reaction-update-action';

import { ReactionUpdateAction } from './loadable';
import { reactionUpdateActionResource } from './resource';

reactionUpdateActionRoute.component = ReactionUpdateAction;
reactionUpdateActionRoute.resources = [reactionUpdateActionResource];
export const reactionUpdateActionRouterRoute: SiteHomePageRoute = reactionUpdateActionRoute;
